import React from 'react';
import { Link } from 'react-router-dom';
import { RiBuilding2Line } from '@remixicon/react';
import { cn } from '@/utils/helpers';

interface OrganizationCellProps {
  organization: {
    id: number;
    name: string;
    desc?: string | null;
  };
  showDescription?: boolean;
  dense?: boolean;
  linked?: boolean;
}

export function OrganizationCell({
  organization,
  showDescription = true,
  dense = false,
  linked = false
}: OrganizationCellProps) {
  const content = (
    <div className="flex items-center gap-1">
      <div className="shrink-0">
        <RiBuilding2Line className={cn('text-default-400 shrink-0', dense ? 'size-4' : 'size-6')} />
      </div>
      <div className="flex min-w-0 flex-col">
        <span className={cn('truncate font-medium', dense && 'text-xs')}>{organization.name}</span>
        {showDescription && organization.desc && (
          <span className={cn('text-default-500 truncate text-xs', dense ? 'line-clamp-1' : 'line-clamp-2')}>
            {organization.desc}
          </span>
        )}
      </div>
    </div>
  );

  if (linked) {
    return (
      <Link to={`/organizations?id=${organization.id}`} className="block transition-opacity hover:opacity-80">
        {content}
      </Link>
    );
  }

  return content;
}
